import clsx from 'clsx';

import {
  Box,
  Card,
  Flex,
  InfoIcon,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@jane/shared/reefer';
import type { QualifyingStatusEnum } from '@jane/shared/types';

import styles from '../specialDetailStatus.module.css';

export interface SpecialDetailStatusStickyProps {
  calloutSubtext?: string;
  calloutText?: string;
  isGold?: boolean;
  onClick: () => void;
  qualifyingStatus?: QualifyingStatusEnum;
  subtext?: string;
  text: string;
}

export const SpecialDetailStatusSticky = ({
  onClick,
  qualifyingStatus,
  calloutSubtext,
  calloutText,
  isGold,
  subtext,
  text,
}: SpecialDetailStatusStickyProps) => {
  const isApplied = qualifyingStatus === 'applied';
  const isQualified = qualifyingStatus === 'qualified';
  const notQualified = qualifyingStatus === 'not_qualified';
  const isUnlocked = isApplied || isQualified;

  return (
    <Card
      border="transparent-black-ten"
      className={styles.border__radius__none}
      width="100%"
      aria-label="view special details"
      onClick={onClick}
    >
      <Card.Content>
        <Flex gap={8}>
          <Flex>
            {isGold && (
              <JaneGoldIcon
                className={clsx({
                  [styles.opacity__not__unlocked]: notQualified,
                })}
              />
            )}
            {!isGold && (
              <TagFilledIcon
                color="info"
                className={clsx({
                  [styles.opacity__not__unlocked]: notQualified,
                })}
              />
            )}
          </Flex>
          <Box overflow="hidden">
            <Typography
              truncateAt="100%"
              overflowWrap="break-word"
              color={isUnlocked ? 'grays-black' : 'grays-mid'}
            >
              {text}
              {subtext && (
                <Typography mx={4} as="span" color="grays-mid">
                  &#8226;
                </Typography>
              )}
              {subtext && (
                <Typography as="span" color="grays-mid">
                  {subtext}
                </Typography>
              )}
            </Typography>

            {calloutText && (
              <Typography truncateAt="100%">
                <Typography variant="body-bold" as="span">
                  {calloutText}
                </Typography>

                {calloutSubtext && (
                  <Typography color="grays-mid" as="span" ml={4}>
                    {calloutSubtext}
                  </Typography>
                )}
              </Typography>
            )}
          </Box>

          <Flex ml="auto">
            <InfoIcon color="grays-mid" />
          </Flex>
        </Flex>
      </Card.Content>
    </Card>
  );
};
